var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw_dashboard_alert"},[_c('tw-table-system',{attrs:{"schemas":_vm.schemas,"height":272,"nopager":true,"items":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }